<kng-banner [state]="bannerState" (bannerClosed)="headerBannerClosed($event)" (alertBannerClosed)="alertBannerClosed($event)" id="header-alert-banner" class="header-alert-banner"></kng-banner>

<kng-shell *ngIf="(stateObservable$ | async) || (sharedService.reviewListPresent$ | async)"
  (labelRedirection)="redirectToSection($event)"
  (locationSelected)="accountManagerSelectedCompany($event)"
  (languageSelectionChanged)="updateApplicationLanguage($event)"
  (bannerClickEvent)="bannerClickHandler($event)"
  (customerSessionEvent)="endCustomerSession()"
  #kngShellComponent
  [state]="state"
  [customerState]="customerState"
>
<div *ngIf="service.reviewListBannerState.open" panelClass = "bannerPanelClass" class="review-list-banner kng-shell__banner" id="review-list-banner" banner-slot>
  <kng-banner 
  *ngIf="service.reviewListBannerState.open"
  class="kng-shell__banner" 
    [state]="service.reviewListBannerState"
    (closeBanner)="closeReviewListBanner($event)"
  ></kng-banner>
</div>
  <div role="content">
    <ol class="breadcrumb" *ngIf = "breadcrumbs.length >1" tabindex="-1">
      <span class="icon-image-mobile"></span>
      <li *ngFor="let breadcrumb of breadcrumbs; let i=index" [ngClass] = "{'hideBreadcrumbLabel': i < breadcrumbs.length-2}">
        <span class="router-first"  *ngIf=" i!==breadcrumbs.length-1" (click)="routerLink(breadcrumb.url)" (keypress)="routerLink(breadcrumb.url)" routerLinkActive="router-link-active" tabindex="0">
          {{ breadcrumb.label }}
        </span>
        <span class="router-last" *ngIf=" i ===breadcrumbs.length-1"  routerLinkActive="router-link-active" tabindex="0">
          {{ breadcrumb.label }}
        </span>
      </li>
    </ol>
    <router-outlet></router-outlet>
    <div class="overlay" *ngIf="service.loading">
      <kng-loader [state]="loaderState"></kng-loader>
    </div>
  </div>
  <div role="footer"></div>
  <div role="modal">
    <div class="modal-card"></div>
  </div>
</kng-shell>

<div class="termsConditions-container" *ngIf="!sharedUtilService.isTmhCustomerSupportRole">
<kng-modal-component #confirmTerms [state]="service.termsAndCondition" *ngIf ="tnc === true && !service.termsAndCondition.hidden" (tooltipClicked)="showTooltip(service.termsAndCondition.label)"
  (ctaClickedOn)="confirmTcEvent($event)" (closed)="closeModal()" [checBoxDisabledFlag]="checkBoxDisabledFlag" (checkBoxClicked)="checkIfTermsAgreed($event)">
  <div  tabindex="0">
    <div tabindex="0" [ngClass]="{'terms-and-conditions-tooltip--hidden' : !showTermsAndConditionsTooltip}" class="terms-and-conditions-tooltip"  
      #toolTipRef role="dialog">
      <button mat-button tabindex="0" (click)="showTermsAndConditionsTooltip = false;" class="terms-and-conditions-tooltip_section terms-and-conditions-tooltip--close-button">    
        <img src="{{service.termsAndCondition.tooltip?.closeIcon?.iconPath}}"
        alt="{{service.termsAndCondition.tooltip?.closeIcon?.altText}}" tabindex="0"/>
      </button>
      <div tabindex="0" class="terms-and-conditions-tooltip_section dialog-heading">
        {{service.termsAndCondition.tooltip?.content}}</div>
    </div>
    <div #terms  id="term-modal" class="track-ScrollBar_Mobile" tabindex="-1" role="dialog" (scroll)="onScrollTandC($event)">
      <div class="info-banner-terms">
        <p class="info-banner-terms-text">{{service.termsAndConditionAEMlabels.updatedTerms.alertNote}}</p>
    </div>
    <p class="content" id='content' *ngFor="let content of service.termsAndConditionAEMlabels.updatedTerms.content" tabindex="0" [innerHTML]="content| safeHtml" role="dialog"></p>
    </div>
  </div>
</kng-modal-component>
</div>

<div class="privacyPolicy-container" *ngIf="!sharedUtilService.isTmhCustomerSupportRole">
<kng-modal-component #confirmPolicy [state]="service.policyState"  *ngIf = "!service.policyState.hidden" (ctaClickedOn)="confirmPolicyEvent($event)" (closed)="closeModal()" 
(tooltipClicked)="showTooltip(service.policyState.label)" [checBoxDisabledFlag]="checkBoxDisabledFlag" (checkBoxClicked)="checkIfPrivacyAgreed($event)">
    <div tabindex="0" [ngClass]="{'privacy-policy-tooltip--hidden' : !showPrivacyPolicyTooltip}" class="privacy-policy-tooltip"  
      #toolTipRef role="dialog">
      <button mat-button tabindex="0" (click)="showPrivacyPolicyTooltip = false;" class="privacy-policy-tooltip_section privacy-policy-tooltip--close-button">    
        <img src="{{service.policyState.tooltip?.closeIcon?.iconPath}}"
        alt="{{service.policyState.tooltip?.closeIcon?.altText}}" tabindex="0"/>
      </button>
      <div tabindex="0" class="privacy-policy-tooltip_section dialog-heading">
        {{service.policyState.tooltip?.content}}</div>
    </div>
    <div #terms id="term-modal" class="track-ScrollBar_Mobile" tabindex="0" role="dialog" (scroll)="onScrollTandC($event)">
       <div class="info-banner-terms">
        <p class="info-banner-terms-text">{{service.policyAEMlabels.updatedPrivacy.alertNote}}</p>
    </div>
    <p class="content" id='content' *ngFor="let content of service.policyAEMlabels.updatedPrivacy.content" tabindex="0" [innerHTML]="content| safeHtml" role="dialog"></p>
  </div>
</kng-modal-component>
</div>

<kng-modal-component *ngIf="!leaveConfirmModalState.hidden" #confirmLeavePage (ctaClickedOn)="confirmLeaveEvent($event)" (closed)="closeModalPopup()"
  [state]="leaveConfirmModalState">
  <div class="confirm-leave-page">
    <p tabindex="0" class="confirm-leave-page--text-section">
      {{confirmLeavePagestate.headingSub}}
    </p>
  </div>
</kng-modal-component>
<div class="congratulatory-modal">
  <kng-modal-component [state]="service.businessAccountRegistrationSuccess.modal"
    *ngIf="!service.businessAccountRegistrationSuccess.modal.hidden" (ctaClickedOn)="closeCongratulatoryModal()"
    (closed)="closeCongratulatoryModal()">
    <div class="congratulatory-modal">
      <img class="congratulatory-modal--image"
        [src]="service.businessAccountRegistrationSuccess.congratulationsImage.iconPath" [alt]=''
        [attr.altText]="service.businessAccountRegistrationSuccess.congratulationsImage.altText" tabindex="0">
      <p class="congratulatory-modal--main-text" tabindex="0">
        {{ service.businessAccountRegistrationSuccess.mainText }}
      </p>
      <p class="congratulatory-modal--sub-text" tabindex="0">
        {{ service.businessAccountRegistrationSuccess.subText }}</p>
    </div>
  </kng-modal-component>
  <kng-modal-component *ngIf="!endSessionModalState.hidden" #confirmEndSession (ctaClickedOn)="confirmEndSessionEvent($event)"
  [state]="endSessionModalState">
  <div class="confirm-leave-page">
    <p tabindex="0" class="confirm-leave-page--text-section">
      {{customerState.endSessionNote}}
    </p>
  </div>
</kng-modal-component>

<kng-modal-component *ngIf="!inactiveSessionModalState.hidden" #inactiveSession (ctaClickedOn)="confirmInactiveSessionEvent($event)"
  [state]="inactiveSessionModalState">
  <div class="confirm-leave-page">
    <p tabindex="0" class="confirm-leave-page--text-section">
      {{customerState.inativityMessage}}
    </p>
    <p tabindex="0" class="confirm-leave-page--text-section">
      {{customerState.inactivityConfirmation}}
    </p>
  </div>
</kng-modal-component>

<kng-modal-component class="dealer-reminder-modal" *ngIf="!reminderModalState.hidden" #reminderSession (ctaClickedOn)="confirmDealerBannerEvent($event)"
  [state]="reminderModalState">
  <div class="confirm-leave-page">
    <p tabindex="0" class="dealer-reminder-desc">
      {{service.reminderModalDesc}}
    </p>
  </div>
</kng-modal-component>

<kng-modal-component class="multiple-role-modal" *ngIf="!service.multipleRoleModalState.hidden" [state]="service.multipleRoleModalState" (ctaClickedOn)="multipleRoleModalEvent($event)" (closed)="crossCta()">
  <span class="option--label">{{service.multipleRoleModalDesc}}</span>
  <mat-radio-group>
    <mat-radio-button value="{{option.id}}" (click)="clickRole = option.id" [checked]="option.id === role" *ngFor="let option of service.multipleRoleOptions; let index = index">
      <div class="option--container">
        <span class="option--heading">{{option.heading}}</span>
        <span class="option--description">{{option.description}}</span>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</kng-modal-component>
</div>
